import { api } from '@/lib/api/client'
import type { Client, ClientHealth } from '@/types/support'
import { fetchAll } from '@/lib/api/paged'

export async function fetchClients(): Promise<Client[]> {
  return fetchAll<Client>('/clients')
}

/**
 * The slug is not sent. It is how a client is addressed in the API, and the
 * server derives it from the name — asking for it would be asking someone to
 * invent a url.
 *
 * Health starts good and is changed on the client itself, where the reason for
 * changing it can be written down next to it.
 */
export async function createClient(input: {
  name: string
  sector?: string | null
  primaryContactName?: string | null
  primaryContactEmail?: string | null
}): Promise<Client> {
  const { data } = await api.post<{ data: Client }>('/clients', input)

  return data.data
}

export interface ClientChanges {
  name?: string
  sector?: string | null
  notes?: string | null
  primaryContactName?: string | null
  primaryContactEmail?: string | null
  health?: ClientHealth
  healthReason?: string | null
}

export async function fetchClient(slug: string): Promise<Client> {
  const { data } = await api.get<{ data: Client }>(`/clients/${slug}`)

  return data.data
}

export async function updateClient(slug: string, changes: ClientChanges): Promise<Client> {
  const { data } = await api.patch<{ data: Client }>(`/clients/${slug}`, changes)

  return data.data
}

export async function deleteClient(slug: string): Promise<void> {
  await api.delete(`/clients/${slug}`)
}
